import React from 'react'
import reactCSS from 'reactcss'
import {
    Saturation,
    Hue,
    Checkboard
} from 'react-color/lib/components/common'
import ChromeFields from './ColorPickerFields'
import ChromePointer from './ColorPickerPointer'
import ChromePointerCircle from './ColorPickerPointerCircle'
import EnhancedPicker from './EnhancedPicker'

export const Picker = ( {onChange, onChangeComplete, rgb, hsl, hsv, hex, renderers} ) => {

    const styles = reactCSS( {
        'default': {
            picker    : {
                background  : '#fff',
                borderRadius: '.15em',
                boxShadow   : '0 0 .15em rgba(0,0,0,.3), 0 .3em .5em rgba(0,0,0,.3)',
                boxSizing   : 'initial',
                width       : '11.1em',
            },
            saturation: {
                width        : '100%',
                paddingBottom: '55%',
                position     : 'relative',
                borderRadius : '.15em .15em 0 0',
                overflow     : 'hidden',
            },
            Saturation: {
                radius: '.15em .15em 0 0',
            },
            body      : {
                padding: '1em 1em .75em',
            },
            controls  : {
                display: 'flex',
            },
            color     : {
                width: '2em',
            },
            swatch    : {
                marginTop : '1em',
                marginLeft: '0.5em',
                width     : '2.5em',
                height    : '2.5em',
                position  : 'relative',
                overflow  : 'hidden',
            },
            active    : {
                absolute    : '0px 0px 0px 0px',
                borderRadius: '.5em',
                boxShadow   : 'inset 0 0 0 .05em rgba(0,0,0,.1)',
                background  : `rgba(${ rgb.r }, ${ rgb.g }, ${ rgb.b }, ${ rgb.a })`,
                zIndex      : '30',
            },
            toggles   : {
                flex: '1',
            },
            fields    : {
                flex: '3 1 0%',
            },
            hue       : {
                height      : '1em',
                position    : 'relative',
                marginBottom: '0px',
            },
            Hue       : {
                radius: '.25em',
            }
        },
    } );

    return (
            <div style={styles.picker} className="chrome-picker">
                <div style={styles.saturation}>
                    <Saturation
                        style={styles.Saturation}
                        hsl={hsl}
                        hsv={hsv}
                        pointer={ChromePointerCircle}
                        onChange={onChange}
                    />
                </div>
                <div style={styles.body}>
                    <div style={styles.hue}>
                        <Hue
                            style={styles.Hue}
                            hsl={hsl}
                            pointer={ChromePointer}
                            onChange={onChange}
                        />
                    </div>

                    <div style={styles.controls} className="flexbox-">
                        <div style={styles.fields}>
                            <ChromeFields
                                rgb={rgb}
                                hsl={hsl}
                                hex={hex}
                                onChange={onChange}
                            />
                        </div>
                        <div style={styles.toggles}>
                            <div style={styles.color}>
                                <div style={styles.swatch}>
                                    <div style={styles.active}/>
                                    <Checkboard renderers={renderers}/>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
    )
};

export default EnhancedPicker( Picker );



// WEBPACK FOOTER //
// ./src/components/recoloring/Picker.js